import { render, staticRenderFns } from "./ExamPaperAssembly.vue?vue&type=template&id=32b6f744&scoped=true"
import script from "./ExamPaperAssembly.vue?vue&type=script&lang=js"
export * from "./ExamPaperAssembly.vue?vue&type=script&lang=js"
import style0 from "./ExamPaperAssembly.vue?vue&type=style&index=0&id=32b6f744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b6f744",
  null
  
)

export default component.exports